import styled from "styled-components";

import "../../GlobalStyles/Font.css";
import { NavLink } from "react-router-dom";

export const NameUser = styled.h1`
  font-size: 20px;
  line-height: 1.2;
  font-family: "Exo2 Light";
  color: #000;

  @media (min-width: 744px) {
    display: flex;
    gap: 10px;
    font-size: 24px;
    line-height: 1.1;
  }

  @media (min-width: 1440px) {
    font-size: 36px;
    line-height: 1.19;
  }
`;

export const NicNameUserColor = styled.span`
  color: #1ac63f;
`;

export const ButtonBackPage = styled(NavLink)`
  width: 56px;
  height: 56px;
  background: #1ac63f;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    cursor: pointer;
  }
`;

export const IconButtonBack = styled.svg`
  fill: #fff;
  width: 24px;
  height: 24px;

  @media (min-width: 744px) {
    width: 13px;
    height: 13px;
  }

  @media (min-width: 1440px) {
    width: 24px;
    height: 24px;
  }
`;

export const ContainerMainInfoPage = styled.div`
  margin: 0 auto;

  @media (min-width: 744px) {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  @media (min-width: 1024px) {
    gap: 210px;
  }

  @media (min-width: 1440px) {
    gap: 310px;
    align-items: flex-start;
  }
`;

export const HeaderMainInfo = styled.div`
  max-width: 100%;
  padding: 16px;
  display: flex;
  align-items: center;
  gap: 20px;

  @media (min-width: 744px) {
    width: 625px;
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  @media (min-width: 1024px) {
    width: 788px;
    padding: 24px;
  }

  @media (min-width: 1440px) {
    width: 1089px;
  }
`;

export const TitlePage = styled.h1`
  margin-left: auto;
  display: none;
  color: #000;

  @media (min-width: 428px) {
  }

  @media (min-width: 744px) {
    display: block;
  }
`;

export const ContainerButton = styled.div`
  max-width: 100%;
  display: flex;
  flex-direction: column;
  gap: 30px;
  padding: 16px;

  @media (min-width: 428px) {
    max-width: 396px;
    margin: 0 auto;
  }

  @media (min-width: 744px) {
    max-width: 348px;
    margin: 0;
  }

  @media (min-width: 1024px) {
    max-width: 309px;
    padding: 24px;
  }

  @media (min-width: 1440px) {
    max-width: 447px;
  }
`;

export const ButtonMainInfo = styled.button`
  width: 100%;
  padding: 18px;
  font-size: 16px;
  line-height: 1.18;
  background: #1ac63f;
  color: #fff;
  font-family: "Exo2 Medium";
  border-radius: 20px;

  &:hover {
    cursor: pointer;
  }

  @media (min-width: 428px) {
    width: 396px;
  }

  @media (min-width: 744px) {
    width: 348px;
  }

  @media (min-width: 1024px) {
    width: 309px;
    font-size: 20px;
    line-height: 1.2;
  }

  @media (min-width: 1440px) {
    width: 447px;
    font-size: 32px;
    line-height: 1.18;
  }
`;

export const ButtonSecurity = styled.button`
  width: 100%;
  padding: 18px;
  font-size: 16px;
  line-height: 1.18;
  transition: 450ms cubic-bezier(0.61, 0, 0.51, 1);
  box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.25);
  background: #fff;
  color: #000;
  font-family: "Exo2 Medium";
  border-radius: 20px;

  &:hover {
    cursor: pointer;
    transition: background 450ms cubic-bezier(0.61, 0, 0.51, 1),
      color 450ms cubic-bezier(0.61, 0, 0.51, 1),
      box-shadow 450ms cubic-bezier(0.61, 0, 0.51, 1);
    background: #1ac63f;
    color: #fff;
    box-shadow: 0px 0px 0px 0px #fff;
  }

  @media (min-width: 428px) {
    width: 396px;
  }

  @media (min-width: 744px) {
    width: 348px;
  }

  @media (min-width: 1024px) {
    width: 309px;
    font-size: 20px;
    line-height: 1.2;
  }

  @media (min-width: 1440px) {
    width: 447px;
    font-size: 32px;
    line-height: 1.18;
  }
`;

export const Languages = styled.button`
  width: 100%;
  padding: 18px;
  font-size: 16px;
  line-height: 1.18;
  transition: 450ms cubic-bezier(0.61, 0, 0.51, 1);
  box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.25);
  background: #fff;
  color: #000;
  font-family: "Exo2 Medium";
  border-radius: 20px;

  &:hover {
    cursor: pointer;
    transition: background 450ms cubic-bezier(0.61, 0, 0.51, 1),
      color 450ms cubic-bezier(0.61, 0, 0.51, 1),
      box-shadow 450ms cubic-bezier(0.61, 0, 0.51, 1);

    background: #1ac63f;
    color: #fff;
    box-shadow: 0px 0px 0px 0px #fff;
  }

  @media (min-width: 428px) {
    width: 396px;
  }

  @media (min-width: 744px) {
    width: 348px;
  }

  @media (min-width: 1024px) {
    width: 309px;
    font-size: 20px;
    line-height: 1.2;
  }

  @media (min-width: 1440px) {
    width: 447px;
    font-size: 32px;
    line-height: 1.18;
  }
`;

export const ButtonModes = styled.button`
  width: 100%;
  padding: 18px;
  font-size: 16px;
  line-height: 1.18;
  transition: 450ms cubic-bezier(0.61, 0, 0.51, 1);
  box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.25);
  background: #fff;
  color: #000;
  font-family: "Exo2 Medium";
  border-radius: 20px;

  &:hover {
    cursor: pointer;
    transition: background 450ms cubic-bezier(0.61, 0, 0.51, 1),
      color 450ms cubic-bezier(0.61, 0, 0.51, 1),
      box-shadow 450ms cubic-bezier(0.61, 0, 0.51, 1);
    background: #1ac63f;
    color: #fff;
    box-shadow: 0px 0px 0px 0px #fff;
  }

  @media (min-width: 428px) {
    width: 396px;
  }

  @media (min-width: 744px) {
    width: 348px;
  }

  @media (min-width: 1024px) {
    width: 309px;
    font-size: 20px;
    line-height: 1.2;
  }

  @media (min-width: 1440px) {
    width: 447px;
    font-size: 32px;
    line-height: 1.18;
  }
`;

export const ButtonLocalData = styled.button`
  width: 100%;
  padding: 18px;
  font-size: 16px;
  line-height: 1.18;
  transition: 450ms cubic-bezier(0.61, 0, 0.51, 1);
  box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.25);
  background: #fff;
  font-family: "Exo2 Medium";
  border-radius: 20px;

  &:hover {
    cursor: pointer;
    transition: background 450ms cubic-bezier(0.61, 0, 0.51, 1),
      color 450ms cubic-bezier(0.61, 0, 0.51, 1),
      box-shadow 450ms cubic-bezier(0.61, 0, 0.51, 1);
    background: #1ac63f;
    color: #fff;
    box-shadow: 0px 0px 0px 0px #fff;
  }

  @media (min-width: 428px) {
    width: 396px;
  }

  @media (min-width: 744px) {
    width: 348px;
  }

  @media (min-width: 1024px) {
    width: 309px;
    font-size: 20px;
    line-height: 1.2;
  }

  @media (min-width: 1440px) {
    width: 447px;
    font-size: 32px;
    line-height: 1.18;
  }
`;

export const ButtonContantUs = styled.button`
  width: 100%;
  padding: 18px;
  font-size: 16px;
  line-height: 1.18;
  transition: 450ms cubic-bezier(0.61, 0, 0.51, 1);
  box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.25);
  background: #fff;
  font-family: "Exo2 Medium";
  border-radius: 20px;

  &:hover {
    cursor: pointer;
    transition: background 450ms cubic-bezier(0.61, 0, 0.51, 1),
      color 450ms cubic-bezier(0.61, 0, 0.51, 1),
      box-shadow 450ms cubic-bezier(0.61, 0, 0.51, 1);
    background: #1ac63f;
    color: #fff;
    box-shadow: 0px 0px 0px 0px #fff;
  }

  @media (min-width: 428px) {
    width: 396px;
  }

  @media (min-width: 744px) {
    width: 348px;
  }

  @media (min-width: 1024px) {
    width: 309px;
    font-size: 20px;
    line-height: 1.2;
  }

  @media (min-width: 1440px) {
    width: 447px;
    font-size: 32px;
    line-height: 1.18;
  }
`;

export const ButtoCredits = styled.button`
  width: 100%;
  padding: 18px;
  font-size: 16px;
  line-height: 1.18;
  transition: 450ms cubic-bezier(0.61, 0, 0.51, 1);
  box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.25);
  background: #fff;
  font-family: "Exo2 Medium";
  border-radius: 20px;

  &:hover {
    cursor: pointer;
    transition:
      background 450ms cubic-bezier(0.61, 0, 0.51, 1),
      color 450ms cubic-bezier(0.61, 0, 0.51, 1),
      box-shadow 450ms cubic-bezier(0.61, 0, 0.51, 1);
    background: #1ac63f;
    color: #fff;
    box-shadow: 0px 0px 0px 0px #fff;
  }

  @media (min-width: 428px) {
    width: 396px;
  }

  @media (min-width: 744px) {
    width: 348px;
  }

  @media (min-width: 1024px) {
    width: 309px;
    font-size: 20px;
    line-height: 1.2;
  }

  @media (min-width: 1440px) {
    width: 447px;
    font-size: 32px;
    line-height: 1.18;
  }
`;

// upload avatar

export const ButtonUploadAvatar = styled.button`
  width: 50px;
  height: 50px;
  background: #1ac63f;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 20px;
  right: 45px;

  &:hover {
    cursor: pointer;
  }

  @media (min-width: 428px) {
    right: 60px;
  }

  @media (min-width: 744px) {
    right: 50px;
  }

  @media (min-width: 1024px) {
    width: 60px;
    height: 60px;
    right: 30px;
  }

  @media (min-width: 1440px) {
    width: 80px;
    height: 80px;
  }
`;

export const ButtonSaveAvatarUser = styled.button`
  max-width: 100%;

  font-size: 16px;
  font-weight: 1.18;
  line-height: 19px;
  padding-top: 19px;
  padding-bottom: 19px;
  margin-top: 50px;
  background: #fff;
  color: #000;
  transition: 450ms cubic-bezier(0.61, 0, 0.51, 1);
  border-radius: 20px;
  box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.25);
  font-family: "Exo2 Medium";

  &:hover {
    cursor: pointer;
    transition: background 450ms cubic-bezier(0.61, 0, 0.51, 1),
      color 450ms cubic-bezier(0.61, 0, 0.51, 1),
      box-shadow 450ms cubic-bezier(0.61, 0, 0.51, 1);
    background: #1ac63f;
    color: #fff;
    box-shadow: 0px 0px 0px 0px #fff;
  }

  @media (min-width: 1024px) {
    font-size: 20px;
    font-weight: 500;
    line-height: 1.2;
  }

  @media (min-width: 1440px) {
    font-size: 32px;
    font-weight: 500;
    line-height: 1.18;
  }
`;

export const MainTitlePage = styled.h1`
  font-size: 20px;
  font-weight: 500;
  line-height: 1.2;
  font-family: "Exo2 Medium";
  text-align: center;

  @media (min-width: 744px) {
    display: none;
  }
`;

// update data user

// avatar

export const UpdateDataUserContainer = styled.div`
  max-width: 358px;
  display: flex;
  gap: 20px;
  flex-direction: column;
  padding: 16px;
  position: relative;

  @media (min-width: 428px) {
    max-width: 396px;

    margin-bottom: 31px;
    margin: 0 auto;
  }

  @media (min-width: 744px) {
    margin: 0;
    max-width: 348px;
  }

  @media (min-width: 1024px) {
    padding: 24px;
    max-width: 448px;
  }
`;

export const AvatarUser = styled.div`
  width: 358px;

  @media (min-width: 428px) {
    width: 396px;
    height: 396px;
  }

  @media (min-width: 744px) {
    width: 348px;
    height: 348px;
  }

  @media (min-width: 1024px) {
    width: 310px;
    height: 310px;
  }

  @media (min-width: 1440px) {
    width: 448px;
    height: 448px;
  }
`;

export const ButtonUpload = styled.input`
  display: none;
`;

// new name user

export const FormNewNameUser = styled.form`
  width: 358px;
  display: flex;
  flex-direction: column;

  @media (min-width: 428px) {
    width: 396px;
  }

  @media (min-width: 744px) {
    width: 348px;
  }

  @media (min-width: 1024px) {
    width: 310px;
  }

  @media (min-width: 1440px) {
    width: 448px;
  }
`;

export const FormNewNameUserInput = styled.input`
  max-width: 100%;
  background: ${({ theme }) => theme?.colors?.updateDataInputBg};
  box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.25);
  padding: 16px 20px;

  font-size: 16px;
  font-weight: 500;
  line-height: 1.18;
  font-family: "Exo2 Medium";
  border-radius: 20px;

  &::placeholder {
    color: ${({ theme }) => theme?.colors?.updateDataInputBgText};
  }

  &.error-animation-input {
    border: 3px solid #e63946;
    border-radius: 20px;
  }

  @media (min-width: 1024px) {
    font-size: 20px;
    font-weight: 500;
    line-height: 1.2;
  }

  @media (min-width: 1440px) {
    font-size: 32px;
    font-weight: 500;
    line-height: 1.18;
  }
`;

export const ErrorMessage = styled.p`
  color: #f44336;
  font-size: 20px;
  font-family: "Exo2 Medium";
  line-height: 1.2;
  margin-top: 0px;
  margin-left: 4px;
  min-height: 0px;
  opacity: 0;
  transform: translateY(-5px);
  transition: transform 250ms cubic-bezier(0.61, 0, 0.51, 1),
    opacity 250ms cubic-bezier(0.61, 0, 0.51, 1),
    min-height 250ms cubic-bezier(0.61, 0, 0.51, 1);

  &.error-animation {
    margin-top: 4px;
    min-height: 15px;
    opacity: 1;
    transform: translateY(5px);
    transition: transform 250ms cubic-bezier(0.61, 0, 0.51, 1),
      opacity 250ms cubic-bezier(0.61, 0, 0.51, 1),
      min-height 250ms cubic-bezier(0.61, 0, 0.51, 1);
  }

  @media (min-width: 1024px) {
    font-size: 16px;
    line-height: 1.18;
  }

  @media (min-width: 1440px) {
    font-size: 20px;
    line-height: 1.2;
  }
`;

export const FormNewNameUserButton = styled.button`
  max-width: 100%;
  font-size: 16px;
  line-height: 1.18;
  transition: 450ms cubic-bezier(0.61, 0, 0.51, 1);
  color: #000;
  background: #fff;
  box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.25);
  font-family: "Exo2 Medium";
  border-radius: 20px;
  margin-top: 20px;
  padding-top: 16px;
  padding-bottom: 16px;

  &:hover {
    cursor: pointer;
    transition: background 450ms cubic-bezier(0.61, 0, 0.51, 1),
      color 450ms cubic-bezier(0.61, 0, 0.51, 1),
      box-shadow 450ms cubic-bezier(0.61, 0, 0.51, 1);
    background: #1ac63f;
    color: #fff;
    box-shadow: 0px 0px 0px 0px #fff;
  }

  @media (min-width: 1024px) {
    font-size: 20px;
    font-weight: 500;
    line-height: 1.2;
  }

  @media (min-width: 1440px) {
    font-size: 32px;
    font-weight: 500;
    line-height: 1.18;
  }
`;

// new email user

export const FormNewEmailUser = styled.form`
  width: 358px;
  display: flex;
  flex-direction: column;

  @media (min-width: 428px) {
    width: 396px;
  }

  @media (min-width: 744px) {
    width: 348px;
  }

  @media (min-width: 1024px) {
    width: 310px;
  }

  @media (min-width: 1440px) {
    width: 448px;
  }
`;

export const FormNewEmailUserInput = styled.input`
  max-width: 100%;
  background: #fff;
  border-radius: 20px;
  box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.25);
  padding: 16px 20px;

  font-size: 16px;
  font-weight: 500;
  line-height: 1.18;
  font-family: "Exo2 Medium";

  &::placeholder {
    color: #808080;
  }

  @media (min-width: 1024px) {
    font-size: 20px;
    font-weight: 500;
    line-height: 1.2;
  }

  @media (min-width: 1440px) {
    font-size: 32px;
    font-weight: 500;
    line-height: 1.18;
  }
`;

export const FormNewEmailUserButton = styled.button`
  width: 100%;
  font-size: 16px;
  line-height: 1.18;
  color: #000;
  background: #fff;
  transition: 450ms cubic-bezier(0.61, 0, 0.51, 1);
  box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.25);
  font-family: "Exo2 Medium";
  border-radius: 20px;
  margin-top: 20px;
  padding-top: 16px;
  padding-bottom: 16px;

  &:hover {
    cursor: pointer;
    transition: background 450ms cubic-bezier(0.61, 0, 0.51, 1),
      color 450ms cubic-bezier(0.61, 0, 0.51, 1),
      box-shadow 450ms cubic-bezier(0.61, 0, 0.51, 1);
    background: #1ac63f;
    color: #fff;
    box-shadow: 0px 0px 0px 0px #fff;
  }

  @media (min-width: 1024px) {
    font-size: 20px;
    font-weight: 500;
    line-height: 1.2;
  }

  @media (min-width: 1440px) {
    font-size: 32px;
    font-weight: 500;
    line-height: 1.18;
  }
`;
